module.exports = "d";


/*****************
 ** WEBPACK FOOTER
 ** ./parsing/extract-amd/d.js
 ** module id = 7
 ** module chunks = 2
 **/